export const QUERY_KEYS = {
  // MAIN LAYOUT
  CONTRACTORS: "contractors",
  DASHBOARD_INSTALLATION_LIST: "dashboardInstallationList",

  // ACCOUNT MANAGER
  GET_STORE: "getStore",

  // DASHBOARD QUERIES
  SUMMARY_GRAPH: "summaryGraph",
  DASHBOARD_FINES: "dashboardFines",
  CAPACITIVE_FINES: "capacitiveFines",
  INDUCTIVE_FINES: "inductiveFines",
  MAX_DEMAND_FINES: "maxDemandFines",
  DASHBOARD_CONSUMPTION_SUMMARY: "dashboardConsumptionSummary",
  DASHBOARD_BILLING_SUMMARY: "dashboardBillingSummary",
  DASHBOARD_GENERATION_SUMMARY: "dashboardGenerationSummary",
  DASHBOARD_MISSED_ADVANTAGE_TABLE: "dashboardMissedAdvantageTable",
  DASHBOARD_MISSED_ADVANTAGE_SINGLE: "dashboardMissedAdvantageSingle",

  // ALARMS
  ACTIVE_ALARMS_LIST: "activeAlarmsList",
  PAST_ALARMS_LIST: "pastAlarmsList",
  DEFINED_ALARMS_LIST: "definedAlarmsList",
  GET_ALARM_OPTIONS: "getAlarmOptions",
  GET_ALARM: "getAlarm",
  GET_USERS: "users",

  // BILLINGS
  CONTEXT_BILLS_TABLE: "contextBillsTable",
  CONTEXT_TOTAL_CARDS: "contextTotalCards",
  CONTEXT_BILL_INFORMATION: "contextBillInformation",
  CONTEXT_BILL_UNIT_PRICES_GRAPH: "contextBillUnitPricesGraph",
  CONTEXT_BILLS_GRAPH: "contextBillsGraph",
  CONTEXT_BILL_DETAILS_GRAPH: "contextBillDetailsGraph",
  INSTALLATION_LIST: "installationList",
  BILLING_ONBOARDING_DATA: "billingOnboardingData",

  // BUDGET PLANNING
  BUDGET_PLANNING_DATA: "budgetPlanningData",
  BUDGET: "budget",
  BUDGET_COMPARISON: "budgetComparison",

  // OSOS
  OSOS_TABLE: "ososTable",
  GET_OSOS: "getOsos",

  // OSOS DETAIL
  OSOS_DETAILS: "ososDetails",

  // OSOS ONBOARDING
  ACCOUNT_STATE: "accountState",
  DISTRIBUTION_COMPANIES: "distributionCompanies",

  // BILLING_PREDICTION
  PREDICTION_ACCURACY_CARD: "predictionAccuracyCard",
  PREDICTION_DAILY_AVERAGE_CARD: "predictionDailyAverageCard",
  PREDICTION_GRAPH: "predictionGraph",
  PREDICTION_REAL_BILL_CARD: "predictionRealBillCard",
  PREDICTION_SUM_CARD: "predictionSumCard",

  // MCP PREDICTION
  MCP_REAL_AVERAGE_CARD: "mcpRealAverageCard",
  MCP_RATIO_CARD: "mcpRatioCard",
  MCP_PREDICTED_AVERAGE_CARD: "mcpPredictedAverageCard",
  MCP_WEIGHTED_AVERAGE_CARD: "mcpWeightedAverageCard",
  MCP_PREDICTED_HEATMAP_CHART: "mcpPredictedHeatmapChart",
  MCP_HOURLY_AVERAGE_CHART: "mcpHourlyAverageChart",
  MCP_DAILY_AVERAGE_CHART: "mcpDailyAverageChart",
  MCP_MONTHLY_AVERAGE_CHART: "mcpMonthlyAverageChart",

  // SENSOR COMPARE
  SENSOR_COMPARE_FILTER: "sensorCompareFilter",

  // SENSORS
  DEVICE_LIST_VIEW: "deviceListView",

  // SENSOR DETAIL
  DEVICE_GRAPHS: "deviceGraphs",

  // ADMINISTRATION
  AUDIT_TABLE: "auditTable",
  CONTACT_LIST: "contactList",
  CONTRACT: "contract",
  OSOS_LIST: "ososList",
  USERS_TABLE: "usersTable",
  USER: "user",

  // SUSTAINABILITY
  COMPARISON: "comparison",
  EMISSION: "emission",
  TREES: "trees",

  // TARIFFS
  TARIFFS: "tariffs",

  // NOTIFICATIONS
  NOTIFICATIONS: "notifications",
  SET_NOTIFICATION_SEEN: "setNotificationSeen",
  DELETE_NOTIFICATION: "deleteNotification",

  // GENERATION
  POWER_STATIONS_TABLE: "getPowerStationsTable",
  POWER_STATIONS_CARDS: "getPowerStationsCards",
  POWER_STATIONS_MAP: "getPowerStationsMap",
  POWER_STATION_DETAILS: "getPowerStationDetails",
};
